/**
 * Types and label resolution for `GaiaEnumSelect`.
 *
 * A sibling module rather than an `export` inside the `.vue`: a plain
 * `<script>` block holding only types is elided before eslint's type program
 * sees it, so importing from the component resolves to an error type there
 * even though vue-tsc is happy with it.
 */

/** Enum members are strings on the wire; numbers are tolerated for local sets. */
export type GaiaEnumValue = string | number;

/**
 * Labels by value, in either shape this folder's status maps use — a plain
 * string, or a descriptor whose `label` is the display text (the rest of the
 * descriptor, e.g. `tone`, is for the chips, not for a select row).
 */
export type GaiaEnumLabels = Record<GaiaEnumValue, string | { label: string }>;

/** The label for one value, falling back to the value itself. */
export function labelFor(value: GaiaEnumValue, labels: GaiaEnumLabels | undefined): string {
  const entry = labels?.[value];
  if (entry === undefined) return String(value);
  return typeof entry === 'string' ? entry : entry.label;
}
